//@flow
import * as React from "react";
import { Redirect } from "react-router-dom";

export class HomePage extends React.Component<{}> {
  render() {
    return <Redirect to="/agenda" />;
  }
}
